import script from "./single-ambiguous-background.vue?vue&type=script&setup=true&lang=js"
export * from "./single-ambiguous-background.vue?vue&type=script&setup=true&lang=js"

import "./single-ambiguous-background.vue?vue&type=style&index=0&id=7028cd34&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7028cd34"]])

export default __exports__